module.exports = __webpack_public_path__ + "assets/075e539b78968acf6b2af8d136508c7b.mp4";